export default "__VITE_ASSET__CdXzWxvZ__"